import Vue from "vue";
import SalaryInfoModalHeader from "../../SalaryInfoModalHeader.vue";
export default Vue.extend({
    props: {
        selectedDate: String,
        salaryRow: {},
    },
    components: {
        SalaryInfoModalHeader,
    },
});
